import { Button, ButtonSizes } from "@src/components";
import { ReactNode, useMemo } from "react";

type Button = {
  content: ReactNode;
  fn: () => void;
  disabled: boolean;
};

export const CashBridgeButton = () => {
  const button: Button = useMemo(() => {
    return {
      content: <div>Move</div>,
      fn: () => {},
      disabled: false,
    };
  }, []);

  return (
    <Button
      disabled={button.disabled}
      onClick={button.fn}
      size={ButtonSizes.Large}
    >
      {button.content}
    </Button>
  );
};
